import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { DrawerButton } from '../../../drawer/drawerButton';
import { DrawerControl } from '../../../drawer/drawerControl';
import { addMessageBox } from '../../../redux/actions/messageBoxesActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { ExitGameButtonGroup } from '../exitGameButtonGroup';
export const PokerDrawerControl = () => {
    const dispatch = useAppDispatch();
    const hasBuyInRange = useAppSelector((state) => state.poker.hasBuyInRange);
    const onClickSetBuyIn = useCallback((closeDrawer) => {
        dispatch(addMessageBox({ type: 'set-buy-in', seatIndex: undefined }));
        closeDrawer();
    }, [dispatch]);
    return (_jsx(DrawerControl, { render: (closeDrawer) => _jsx(ExitGameButtonGroup, { onClose: closeDrawer }), renderSecondarySection: (closeDrawer) => hasBuyInRange && _jsx(DrawerButton, { label: 'Set Buy-in', onClick: () => onClickSetBuyIn(closeDrawer) }) }));
};
